import { render, staticRenderFns } from "./radarChart.vue?vue&type=template&id=4298c7c8&scoped=true"
import script from "./radarChart.vue?vue&type=script&lang=js"
export * from "./radarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4298c7c8",
  null
  
)

export default component.exports